var EntityProcedureEnum = /* @__PURE__ */ ((EntityProcedureEnum2) => {
  EntityProcedureEnum2["ENTITY_PROCEDURE_CARD"] = "entity-procedure-card";
  EntityProcedureEnum2["ENTITY_PROCEDURE_ACTIONS_PRICE"] = "entity-procedure-actions--price";
  EntityProcedureEnum2["ENTITY_PROCEDURE_ACTIONS_INSTALLMENT"] = "entity-procedure-actions--installment";
  EntityProcedureEnum2["ENTITY_PROCEDURE_ACTIONS_PRICE_BUTTON"] = "entity-procedure-actions--price-button";
  EntityProcedureEnum2["ENTITY_PROCEDURE_ACTIONS_SEE_SCHEDULE_BUTTON"] = "entity-procedure-actions-see-schedule-button";
  EntityProcedureEnum2["ENTITY_PROCEDURE_AVATAR"] = "entity-procedure-avatar";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PROFILE_PROFESSIONAL_NAME"] = "entity-procedure-profile--professional-name";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PROFILE_PARTNER_NAME"] = "entity-procedure-profile--partner-name";
  EntityProcedureEnum2["ENTITY_PROCEDURE_TELEHEALTH_LABEL"] = "entity-procedure-telehealth-label";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PILL"] = "entity-procedure-pill";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PILL_ICON"] = "entity-procedure-pill--icon";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PILL_LABEL"] = "entity-procedure-pill--label";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PILL_ORIGINAL_PRICE"] = "entity-procedure-pill--original-price";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PILL_PRICE"] = "entity-procedure-pill--price";
  return EntityProcedureEnum2;
})(EntityProcedureEnum || {});
export {
  EntityProcedureEnum
};
